import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function ForYouSection() {
  const isForYou = ['Querés emprender desde casa con algo creativo y con demanda.', 'Preferís empezar chico y crecer con método.', 'Querés vender más sin depender solo de "subir fotos bonitas".', 'Necesitás orden y un plan que puedas seguir aunque tengas poco tiempo.'];
  const notForYou = ['Buscás "plata fácil" sin trabajar en oferta, precio y ventas.', 'No querés hablar con clientas ni usar redes/mensajes para vender.', 'Querés un curso de repostería avanzada: acá el foco es negocio rentable, no técnicas chef.'];
  return <section className="py-20 md:py-28 bg-white" data-id="element-130">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-131">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-132">
          {/* Is For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-green-50 rounded-3xl p-8 md:p-10 border-2 border-green-200 shadow-lg" data-id="element-133">
            <h3 className="text-3xl font-extrabold text-coffee-dark mb-8 font-heading flex items-center" data-id="element-134">
              <span className="bg-green-500 text-white rounded-full w-10 h-10 flex items-center justify-center mr-4" data-id="element-135">
                ✓
              </span>
              Esto es para vos si…
            </h3>
            <ul className="space-y-6" data-id="element-136">
              {isForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-137">
                  <CheckCircle2Icon className="w-6 h-6 text-green-600 mr-4 flex-shrink-0 mt-1" data-id="element-138" />
                  <span className="text-lg text-coffee-dark font-medium" data-id="element-139">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50 rounded-3xl p-8 md:p-10 border-2 border-red-200 shadow-lg" data-id="element-140">
            <h3 className="text-3xl font-extrabold text-coffee-dark mb-8 font-heading flex items-center" data-id="element-141">
              <span className="bg-red-500 text-white rounded-full w-10 h-10 flex items-center justify-center mr-4" data-id="element-142">
                ✕
              </span>
              Y no es para vos si…
            </h3>
            <ul className="space-y-6" data-id="element-143">
              {notForYou.map((item, index) => <li key={index} className="flex items-start" data-id="element-144">
                  <XCircleIcon className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-145" />
                  <span className="text-lg text-coffee-dark font-medium" data-id="element-146">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}